import React from 'react';
import { offer } from '../data/offer';
import { useCountdown } from '../contexts/CountdownContext';
export function PromoBar() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <div className="sticky top-0 z-50 border-b border-espresso-line bg-espresso/95 backdrop-blur" data-id="element-232" data-mp="3i6yl1kb3vr7">
      <div className="flex items-center justify-between gap-3 px-4 py-2.5" data-id="element-233" data-mp="3upjktv01qzdz">
        <p className="min-w-0 truncate text-xs text-ivory" data-id="element-234" data-mp="3qnetj2x2meui">
          <span className="font-bold tracking-wider text-wood" data-id="element-235" data-mp="3qozm4mztrnpq">PROMO</span>{' '}
          <span className="font-medium" data-id="element-236" data-mp="3lnad1cw5xk4a">
            Pack + {offer.bonusCount} bonus — {offer.price}
          </span>
        </p>
        <p className="flex shrink-0 items-center gap-2" data-id="element-237" data-mp="3gph266jx01xo">
          <span className="text-[10px] font-semibold uppercase tracking-[0.16em] text-sand" data-id="element-238" data-mp="3bqxjqg4j58a2">Termina tra</span>
          <span className="text-sm font-bold tabular-nums text-wood" aria-live="off" data-id="element-239" data-mp="1ewsvfn82awd5">
            {hours}:{minutes}:{seconds}
          </span>
        </p>
      </div>
    </div>;
}